import React from 'react'
import { Spinner } from '@reward-platform/lift/components'
import useIntl from '~/hooks/useIntl/useIntl'
import styles from './SpinnerOverlay.module.scss'

function SpinnerOverlay(): JSX.Element {
  const intl = useIntl()

  const t = {
    header: intl.formatMessage({
      id: 'spinner-header',
      defaultMessage: 'One moment please!',
    }),
    subheader: intl.formatMessage({ id: 'spinner-subheader', defaultMessage: 'Loading…' }),
  }

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.header}>{t.header}</h2>
      <h5 className={styles.subheader}>{t.subheader}</h5>
      <Spinner role="progressbar" title="Spinner" />
    </div>
  )
}

export default SpinnerOverlay
